export const PATH_PERMISSION = {
  '/': null,
  '/audit-logs': 'logs:read',
  '/network-map': 'assets:read',
  '/assets': 'assets:read',
  '/sbom': 'sbom:read',
  '/baseline': 'assets:read',
  '/drift-alerts': 'assets:read',
  '/mycert': 'events:read',
  '/feed-monitoring': 'events:read',
  '/indicator-vault': 'events:read',
  '/advisor': 'playbooks:view',
  '/risk-assessment': 'events:read',
  '/org/members': 'users:read',
  '/integrations': 'system:update',
  '/scanner': 'assets:read',
  '/vulnerabilities': 'assets:read',
  '/agents': 'assets:read',
  '/platform/organizations': null,
};

export const PERMISSION_PAGES = {
  'events:read': ['MyCERT Insights', 'Feed Monitoring', 'Indicator Vault', 'Risk Assessment'],
  'assets:read': ['Network Map', 'MyAssets', 'Baseline Management', 'Active Alerts', 'Scanner', 'Vulnerabilities', 'Agent Registry'],
  'sbom:read': ['SBOM Records'],
  'logs:read': ['System Audit Logs'],
  'playbooks:view': ['ChatOps Console'],
  'system:update': ['Integration Setup'],
  'users:read': ['Members & Roles'],
  'events:create': [],
  'assets:create': [],
  'assets:update': [],
  'assets:delete': [],
  'sbom:generate': [],
  'users:create': [],
  'users:update': [],
  'users:delete': [],
  'users:password_reset': [],
  'roles:read': [],
  'roles:create': [],
  'roles:update': [],
  'roles:delete': [],
  'roles:assign': [],
  'playbooks:approve': [],
  'chatops:view': [],
  'chatops:execute': [],
  'reports:read': [],
  'reports:create': [],
  'reports:update': [],
  'reports:delete': [],
  'orgs:create': [],
};

export const APP_PAGES = [
  { path: '/network-map', label: 'Network Map', actions: [] },
  { path: '/assets', label: 'MyAssets', actions: [
    { label: 'View assets',    perm: 'assets:read' },
    { label: 'Add assets',     perm: 'assets:create' },
    { label: 'Edit assets',    perm: 'assets:update' },
    { label: 'Delete assets',  perm: 'assets:delete' },
  ]},
  { path: '/sbom', label: 'SBOM Records', actions: [
    { label: 'View SBOM',      perm: 'sbom:read' },
    { label: 'Generate SBOM',  perm: 'sbom:generate' },
  ]},
  { path: '/baseline', label: 'Baseline Management', actions: [] },
  { path: '/drift-alerts', label: 'Active Alerts', actions: [] },
  { path: '/scanner', label: 'Scanner', actions: [] },
  { path: '/vulnerabilities', label: 'Vulnerabilities', actions: [] },
  { path: '/agents', label: 'Agent Registry', actions: [] },
  { path: '/mycert', label: 'Local Insights (MyCERT)', actions: [] },
  { path: '/feed-monitoring', label: 'Feed Monitoring', actions: [] },
  { path: '/indicator-vault', label: 'Indicator Vault', actions: [] },
  { path: '/advisor', label: 'ChatOps Console', actions: [
    { label: 'View playbooks',    perm: 'playbooks:view' },
    { label: 'Approve playbooks', perm: 'playbooks:approve' },
  ]},
  { path: '/risk-assessment', label: 'Risk Assessment', actions: [] },
  { path: '/org/members', label: 'Members & Roles', actions: [
    { label: 'View members',     perm: 'users:read' },
    { label: 'Invite members',   perm: 'users:create' },
    { label: 'Edit members',     perm: 'users:update' },
    { label: 'Remove members',   perm: 'users:delete' },
    { label: 'Reset passwords',  perm: 'users:password_reset' },
    { label: 'Manage roles',     perm: 'roles:assign' },
  ]},
  { path: '/integrations', label: 'Integration Setup', actions: [
    { label: 'Manage Settings', perm: 'system:update' },
  ]},
];

export const PAGE_PERMISSIONS = {};
APP_PAGES.forEach(page => {
  if (page.actions.length) {
    PAGE_PERMISSIONS[page.path] = page.actions.map(a => a.perm);
  }
});
const _fallbackPerms = {
  '/network-map':      ['assets:read'],
  '/baseline':         ['assets:read'],
  '/drift-alerts':     ['assets:read'],
  '/mycert':           ['events:read'],
  '/feed-monitoring':  ['events:read'],
  '/indicator-vault':  ['events:read'],
  '/risk-assessment':  ['events:read'],
};
APP_PAGES.forEach(page => {
  if (!PAGE_PERMISSIONS[page.path]) {
    PAGE_PERMISSIONS[page.path] = _fallbackPerms[page.path] || [];
  }
});

export const PERMISSION_PAGES_MAP = {
  'assets:read':           ['/network-map', '/assets', '/baseline', '/drift-alerts', '/scanner', '/vulnerabilities', '/agents'],
  'assets:create':         ['/assets'],
  'assets:update':         ['/assets'],
  'assets:delete':         ['/assets'],
  'sbom:read':             ['/sbom'],
  'sbom:generate':         ['/sbom'],
  'events:read':           ['/mycert', '/feed-monitoring', '/indicator-vault', '/risk-assessment'],
  'playbooks:view':        ['/advisor'],
  'playbooks:approve':     ['/advisor'],
  'users:read':            ['/org/members'],
  'users:create':          ['/org/members'],
  'users:update':          ['/org/members'],
  'users:delete':          ['/org/members'],
  'users:password_reset':  ['/org/members'],
  'roles:assign':          ['/org/members'],
  'system:update':         ['/integrations'],
};
